import yaraPic from "@/public/images/artists/yara.png";
import { Artist } from "@/types/types";

export const yara = {
  id: "283",
  name: "Yara",
  image: yaraPic,
  description: `Yara has a bright, airy voice with a soft edge that can step up into bigger, more expressive belts.`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Fyara-preview.mp3",
  meta: {
    free: false,
    new: false,
  },
  filters: {
    gender: "Female",
    tags: {
      primary: [
        "Belting",
        "Unprocessed",
        "Pop",
        "Dance",
        "RnB",
        "Soul",
        "Disco",
      ],
      secondary: [],
    },
    pitchRange: {
      categories: {
        low: "Mid",
        high: "High",
      },
      specific: {
        low: 54,
        high: 72,
      },
      sweetSpot: 64,
    },
  },
} satisfies Artist;
